import {RouterModule, Routes} from '@angular/router';

import {NgModule} from '@angular/core';
import {AuthGuard} from '@myServices/auth-guard';

const routes: Routes = [
    {
        path: '',
        loadChildren: './Modules/Home/home-module/home.module#HomeModule'
    },
    {
        path: 'profile',
        loadChildren: './Modules/User/user-module/user.module#UserModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'casino',
        loadChildren: './Modules/Casino/casino-module/casino.module#CasinoModule'
    },
    {
        path: 'live-casino',
        loadChildren: './Modules/LiveCasino/live-casino-module/live-casino.module#LiveCasinoModule'
    },
    {
        path: 'virtual-sports',
        loadChildren: './Modules/VirtualBetting/virtual-betting-module/virtual-betting.module#VirtualBettingModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'header-game',
        loadChildren: './Modules/HeaderGame/header-game-module/header-game.module#HeaderGameModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'tv-bet',
        loadChildren: './Modules/TvBet/tv-bet-module/tv-bet.module#TvBetModule',
        canActivate: [AuthGuard]
    },
    {
        path: 'number-games',
        loadChildren: './Modules/NumberGames/number-games-module/number-games.module#NumberGamesModule',
        // canActivate: [AuthGuard]
    },
    {
        path: 'virtuals',
        loadChildren: './Modules/Virtuals/virtuals-module/virtuals.module#VirtualsModule',
        // canActivate: [AuthGuard]
    },
    {
        path: 'crash-games',
        loadChildren: './Modules/CrashGames/crash-games-module/crash-games.module#CrashGamesModule',
        canActivate: [AuthGuard]
    },
    {
        path: '**',
        redirectTo: ''
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {useHash: true})],
    exports: [RouterModule]
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// C:/Users/beyn/Documents/GitLab/spinmatic-casino/src/app/app-routing.module.ts